import axiosIns from "@axios"

export default {
	namespaced: true,
	state: {
		user: null,
		users: null,
		roles: null,
		userOptions: [],
		openEditModal: false,
		openWelcomeModal: false,
		selectedUser: null,
		validatedEmail: 0
	},
	getters: {
	},
	mutations: {
		toggleEditModal(state, payload){
			state.openEditModal = payload
		},
		toggleWelcomeModal(state, payload){
			state.openWelcomeModal = payload
		},
		updateUserTable(state, payload){
			const index = state.users.findIndex(x => x.id == payload.id)
			if(index != -1){
				state.users[index].max_leads = payload.max_leads
			}
		},
		setUser(state, payload) { state.user = payload },
		addUserToTable(state, payload) { 
			const index = state.users.findIndex(x => x.cms_user_id == payload.cms_user_id)
			if(index == -1){
				state.users.push(payload)
			}else{
				state.users.splice(index,1, payload)
			}
		},
		setValidatedEmail(state, payload) { state.validatedEmail = payload },
		setSelectedUser(state, payload) { state.selectedUser = payload },
		setUsers(state, payload) { state.users = payload },
		setRoles(state, payload) { state.roles = payload },
		setUserOptions(state, payload) { 
			state.userOptions = payload.map(user => {
				return {text: user.firstname, value: user.id}
			}) 
		},
	},
	actions: {
		async getUserByEmail(_, payload) {
			const { email } = payload
			return axiosIns
				.post(`/users/get-by-email`, { email })
		},
		async getUserListAction({ state, commit }, payload) {
			axiosIns
				.get(`/users`)
				.then(result => {
					commit('setUserOptions', result.data)
				})
		},
		async getUsers({ state, commit }, payload) {
			axiosIns
				.get(`/users`)
				.then(result => {
					commit('setUsers', result.data)
				})
		},
		async createUser({ state, commit }, payload) {
			return axiosIns
				.post(`/users/welcome`, payload)
		},
		async sendWelcome({ state, commit }, payload) {
			return axiosIns
				.post(`/auth/welcome`, payload)
				.then(response => {
				})
		},
		async updateUser({ state, commit }, payload) {
			return axiosIns
				.patch(`/users/${payload.id}`, payload.data)
				.then(response => {
					return response
				})
		},
		async change({ commit }, payload) {
            const { token, newPassword } = payload
            return axiosIns
                .post('/auth/change-password', 
                    {
                        token,
                        newPassword
                    })
                    .then(response => {
                        return response
                    })
        },
		async forgot({ commit }, payload) {
            const { email } = payload
            return axiosIns
                .post('/auth/forgot', 
                    {
                        email
                    })
                    .then(response => {
                        return response
                    })
        },
		async deleteUser({ state, commit }, payload) {
			axiosIns
				.post(`/users`, payload)
				.then(result => {
				})
		},
		async checkUser({ state, commit }, payload) {
			axiosIns
				.post(`/users`, payload)
				.then(result => {
				})
		}
	},
}
